import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getAgendaCategories, saveAgendaCategoriesBatch } from '../../api/agenda';
import type { AgendaCategory } from '../../types/Agenda';
import { t } from '../../i18n/t';

const columnDefs: ColDef<AgendaCategory>[] = [
  {
    field: 'categoryId',
    headerName: t('agendaCategories.columns.categoryId'),
    width: 110,
    // IDENTITY PK — server-assigned, never edited.
    editable: false,
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'categoryName',
    headerName: t('agendaCategories.columns.categoryName'),
    flex: 1,
    minWidth: 200,
    editable: true,
  },
  {
    field: 'isActive',
    headerName: t('agendaCategories.columns.isActive'),
    width: 110,
    editable: true,
    cellDataType: 'boolean',
  },
];

const newDefaults = (): Partial<AgendaCategory> => ({
  categoryId: 0,
  categoryName: '',
  isActive: true,
});

export function AgendaCategoriesPage() {
  return (
    <LopCrudPage<AgendaCategory>
      resourceCode="agendaCategories"
      titleKey="agendaCategories.pageTitle"
      idField="categoryId"
      getRows={getAgendaCategories}
      saveBatch={(added, modified, deletedIds) =>
        saveAgendaCategoriesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newDefaults}
    />
  );
}
